import { fromFetch } from 'rxjs/fetch';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';
import { speedCoachingProfileSchema } from '../schemas/speed-coaching-profile.schema';

/**
 * Returns a specific Speed Coaching Profile
 * @param id The ID of the Speed Coaching profile
 * @returns The Speed Coaching Profile
 */
export function getSpeedCoachingId(this: unknown, id: number) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(`${fleetEnvironment.resolve(this).speedCoachingUrl}/${id}`, {
        method: 'GET',
        headers: {
          ...requiredHeaders,
          ...jwtAuthHeaders,
        },
      })
    )
  ).pipe(selectData(speedCoachingProfileSchema));
}
